import { useContext } from "react";
import { IdentityContext } from "./IdentityContext";

const useIdentityContext = () => {
  return useContext(IdentityContext);
};

export default useIdentityContext;
